import {
  Colors,
  flex,
  flexAlignCenter,
  flexColumn,
  flexRow,
  styled,
  Theme,
} from '@unfold/theme';

export const PreferencesWrapper = styled.div`
  width: 100%;
  padding: 52px 108px 60px;
`;

export const FormWrapper = styled.div`
  margin: 60px 0;
  max-width: 380px;
  ${flexColumn}
`;

export const FormRow = styled.div`
  ${flexColumn}

  & + div {
    margin-top: 21px;
  }
`;

export const FormRowInline = styled.div`
  ${flex}
  justify-content: space-between;

  & + div {
    margin-top: 21px;
  }
`;

export const FormLabel = styled.label`
  margin-bottom: 12px;
  color: ${({ theme }): string =>
    theme.name === Theme.LIGHT ? Colors.G100 : Colors.G300};
  font-size: 14px;
  line-height: 17px;
`;

export const FormError = styled.div`
  margin-top: 5px;
  font-size: 11px;
  color: ${({ theme }): string =>
    theme.name === Theme.LIGHT ? Colors.R500 : Colors.R200};
`;

export const AvatarContainer = styled(FormRow)`
  ${flexAlignCenter}
  ${flexRow}
  margin-bottom: 14px;
`;

export const AvatarLabel = styled.div`
  font-size: 14px;
  line-height: 19px;
  color: ${({ theme }): string =>
    theme.name === Theme.LIGHT ? Colors.G300 : Colors.G600};
  margin-left: 22px;
`;

export const AvatarButtonsContainer = styled.div`
  margin-left: 22px;
  margin-top: 7px;
  & > button {
    display: inline-block;
    margin-right: 10px;
    text-transform: uppercase;
  }
`;

export const AvatarImage = styled.img`
  width: 75px;
  height: 75px;
  border-radius: 100%;
`;